import type { Skin } from '@/libs/campaigns/types';
import { christmas2025Skin } from '@/libs/campaigns/christmas-2025/skin';
import { halloween2026Skin } from '@/libs/campaigns/halloween-2026/skin';

/**
 * Every Campaign the site can show, keyed by Campaign id (`<name>-<year>`).
 * The `campaign.active` flag variant selects one; removing a Campaign means
 * deleting its entry and its assets folder.
 */
export const CAMPAIGN_REGISTRY = {
  'christmas-2025': christmas2025Skin,
  'halloween-2026': halloween2026Skin,
} as const satisfies Record<string, Skin>;

export type CampaignId = keyof typeof CAMPAIGN_REGISTRY;

export function isCampaignId(value: string | null | undefined): value is CampaignId {
  return typeof value === 'string' && Object.hasOwn(CAMPAIGN_REGISTRY, value);
}

/** A flag variant the registry doesn't know means there is no Active Campaign. */
export function resolveActiveCampaignId(variant: string | null | undefined): CampaignId | null {
  return isCampaignId(variant) ? variant : null;
}

export function getSkin(campaignId: CampaignId | null): Skin | null {
  return campaignId === null ? null : CAMPAIGN_REGISTRY[campaignId];
}
